import * as yup from 'yup';

const modes = ['development', 'production', 'test', 'demo'] as const;
type Mode = (typeof modes)[number];

const configSchema = yup.object({
    VITE_CANCEL_SUBSCRIPTION_SURVEY_ID: yup.string().required(),
    MODE: yup
        .mixed<Mode>()
        .oneOf([...modes])
        .required(),
    VITE_BETTERSTACK_SOURCE_TOKEN: yup.string().required(),
    VITE_BETTERSTACK_ENDPOINT: yup.string().url(),
    VITE_STRIPE_PUBLIC_API_KEY: yup.string().required(),
    VITE_REACT_APP_PAGE_TITLE: yup.string().default('Upheal App'),
});

export const envConfig = configSchema.validateSync(import.meta.env);
